import { render } from "./StreamPlayer.vue?vue&type=template&id=265e52ad&scoped=true&bindings={\"stream\":\"props\",\"domId\":\"props\"}"
import script from "./StreamPlayer.vue?vue&type=script&lang=js"
export * from "./StreamPlayer.vue?vue&type=script&lang=js"

import "./StreamPlayer.vue?vue&type=style&index=0&id=265e52ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-265e52ad"

export default script